import { Component } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: stretch;
  justify-content: space-between;
  background-color: #CCC2C2;
  height: 100%;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-around;
  background-color: #965A38;
`;

const HeaderSection = styled.div`
  padding: 10px;
  flex: 1;
  background-color: ${props => props.highlighted ? '#A8A8A8' : 'transparent'};
`;

const HeaderTitle = styled.div`
  font-size: 16px;
  padding-top: 5px;
  font-family: 'lcdsolid';
  color: ${props => props.highlighted ? '#965A38' : '#A8A8A8'};
  text-align: center;
`;

const HeaderValue = styled.div`
  font-size: 24px;
  font-family: 'lcdsolid';
  color: ${props => props.highlighted ? '#965A38' : '#A8A8A8'};
  text-align: center;
`;

const LogoContainer = styled.div`
  align-self: center;
  padding: 10px;
`;

const Logo = styled.img`
  max-width: 100%;
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PointsText = styled.div`
  align-self: center;
  font-size: 36px;
  font-family: 'lcdsolid';
  padding: 20px;
  color: #555555;
`;

const GetReadyText = styled.div`
  align-self: center;
  font-size: 36px;
  font-family: 'lcdsolid';
  padding: 20px;
  color: #555555;
`;

const SpecialButton = styled.button`
  align-self: center;
  border-radius: 30px;
  background-color: ${props => props.active ? '#D9A441' : '#965A38'};
  height: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
`;

const SpecialButtonText = styled.span`
  font-family: 'lcdsolid';
  font-size: ${props => props.fontSize || '20px'};
  color: ${props => props.active ? '#965A38' : '#D9A441'};
  transform: ${props => props.variant === 'heart' ? 'translateY(5px)' : 'none'};
`;

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: space-around;
`;

const UserNameContainer = styled.div`
  align-self: center;
  padding: 0 10px;
`;

const UserName = styled.div`
  font-size: 24px;
  font-family: 'lcdsolid';
  color: #555555;
  text-align: center;
`;

const StatsContainer = styled.div`
  padding: 10px 10px 10px 0;
`;

const StatsValue = styled.div`
  font-size: 24px;
  font-family: 'lcdsolid';
  color: #555555;
  text-align: center;
`;

const StatsLabel = styled.div`
  font-size: 16px;
  padding-top: 5px;
  font-family: 'lcdsolid';
  color: #555555;
`;

const GameOverContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

const FacebookButton = styled.a`
  display: flex;
  align-items: center;
  align-self: center;
  border-radius: 4px;
  background-color: #965A38;
  padding: 5px 15px 15px 15px;
  text-decoration: none;
`;

const BackButton = styled.button`
  align-self: center;
  border-radius: 4px;
  background-color: #965A38;
  padding: 15px;
  margin: 15px;
  border: none;
  cursor: pointer;
`;

const ButtonImage = styled.img`
  margin-right: 5px;
`;

const ButtonText = styled.span`
  font-family: 'lcdsolid';
  font-size: ${props => props.fontSize || '22px'};
  color: #D9A441;
  text-align: center;
  padding-top: ${props => props.paddingTop || '7px'};
  padding-left: ${props => props.paddingLeft || '5px'};
`;

export default class Quiz extends Component {
  constructor(props) {
    super(props);

    this.state = {
      points: 0,
      totalPoints: 0,
      opacity: 1
    };
  }

  componentDidMount() {
    this.displayAnswer({}, this.props);
    this.addPoints({ details: { points: 0 } }, this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.displayAnswer(this.props, nextProps);
    this.addPoints(this.props, nextProps);
  }

  displayAnswer(props, nextProps) {
    if (props.status !== 'answer' && nextProps.status === 'answer') {
      let count = 0;
      if (nextProps.answer) {
        const interval = setInterval(() => {
          this.setState({ opacity: this.state.opacity ? 0 : 1 });
          count++;
          if (count > 4) {
            clearInterval(interval);
          }
        }, 500);
      }
      this.setState({ correctOptionIndex: nextProps.answer ? nextProps.answer.correctOption : null, opacity: 0 });
    }
  }

  addPoints(props, nextProps) {
    if (props.details?.points !== nextProps.details?.points) {
      this.setState({ points: nextProps.details.points - props.details.points });
      setTimeout(() => {
        const interval = setInterval(() => {
          const delta = this.state.points >= 10 ? 10 : this.state.points;
          const points = this.state.points - delta;
          this.setState({ points, totalPoints: this.state.totalPoints + delta });
          if (!points) {
            clearInterval(interval);
          }
        }, 50);
      }, 1000);
    }
  }

  handleGuess(optionIndex) {
    this.props.onGuess(optionIndex);
  }

  handleHalf() {
    this.props.onHalf();
  }

  handleHeart() {
    this.props.onHeart();
  }

  renderOptionButton(optionIndex, additionalStyle = {}) {
    const shouldHide = this.props.answer &&
      optionIndex === this.props.answer.correctOptionIndex &&
      !this.state.opacity;

    const isSelected = this.props.answer && optionIndex === this.props.answer.userOptionIndex;
    const isVisible = this.props.question?.options && this.props.question.options[optionIndex];

    return (
      <button
        onClick={() => isVisible && this.handleGuess(optionIndex)}
        disabled={!isVisible || shouldHide}
        style={{
          padding: '12px',
          minHeight: '70px',
          minWidth: '120px',
          borderRadius: '8px',
          backgroundColor: shouldHide
            ? 'transparent'
            : isSelected
            ? '#D9A441'
            : isVisible
            ? '#965A38'
            : 'rgba(0, 0, 0, 0.0)',
          border: 'none',
          textAlign: 'center',
          cursor: `${isVisible && !shouldHide ? 'pointer' : 'default'}`,
          visibility: shouldHide ? 'hidden' : 'visible',
          ...additionalStyle
        }}
      >
        <span
          style={{
            fontFamily: 'lcdsolid',
            fontSize: '16px',
            color: isSelected ? '#965A38' : '#D9A441',
            textAlign: 'center'
          }}
        >
          {this.props.question?.options?.[optionIndex] || ''}
        </span>
      </button>
    );
  }

  renderHalfButton() {
    if (this.props.answer) {
      return null;
    }

    const isActive = this.props.question?.half;

    return (
      <SpecialButton 
        active={isActive}
        onClick={() => this.handleHalf()}
      >
        <SpecialButtonText active={isActive}>50%</SpecialButtonText>
      </SpecialButton>
    );
  }

  renderHeartButton() {
    if (!this.props.answer) {
      return null;
    }

    const isActive = this.props.question?.heart;

    return (
      <SpecialButton 
        active={isActive}
        onClick={() => this.handleHeart()}
      >
        <SpecialButtonText active={isActive} variant="heart" fontSize="48px">{'\u00A8'}</SpecialButtonText>
      </SpecialButton>
    );
  }

  renderPoints() {
    if (this.props.status !== 'answer') {
      return null;
    }
    return <PointsText>{this.state.points}</PointsText>;
  }

  renderCountdown() {
    if (this.props.status !== 'question') {
      return null;
    }
    return <PointsText>{this.props.clock.countdown}</PointsText>;
  }

  renderGetReady() {
    if (this.props.status !== 'getReady') {
      return null;
    }
    return <GetReadyText>Get ready!</GetReadyText>;
  }

  renderOptions() {
    if (this.props.status !== 'question' && this.props.status !== 'answer') {
      return null;
    }
    
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        width: '100%',
        fontSize: 32, 
        gap: '32px',
      }}>
        {this.renderOptionButton(0, { width: '180px', height: 'fit-content' })}
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'stretch', 
          gap: 30, 
          padding: '0 30px'
        }}>
          {this.renderOptionButton(3)}
        
          {this.renderHalfButton()}
          {this.renderHeartButton()}
        
          {this.renderOptionButton(1)}
        </div>
        
        {this.renderOptionButton(2, { width: '180px', height: 'fit-content' })}
      </div>
    );
  }

  renderGameOver() {
    if (this.props.status !== 'gameover') {
      return null;
    }
    
    return (
      <GameOverContainer>
        <FacebookButton href="https://www.facebook.com/eyoquickquiz" target="_blank">
          <ButtonImage src="/images/like.png" alt="Like" />
          <ButtonText>eyo on facebook</ButtonText>
        </FacebookButton>
        
        <BackButton onClick={() => this.props.onBack()}>
          <ButtonText fontSize="16px" paddingTop="0" paddingLeft="0">Back</ButtonText>
        </BackButton>
      </GameOverContainer>
    );
  }

  render() {
    return (
      <Container>
        <div>
          <Header>
            <HeaderSection>
              <HeaderValue>{this.state.totalPoints}</HeaderValue>
              <HeaderTitle>score</HeaderTitle>
            </HeaderSection>
            
            <HeaderSection highlighted>
              <HeaderValue highlighted>
                {this.props.details?.position || ''}/{this.props.details?.totalPlayers || ''}
              </HeaderValue>
              <HeaderTitle highlighted>position</HeaderTitle>
            </HeaderSection>
            
            <HeaderSection>
              <HeaderValue>{this.props.details?.pointsBehindFirst || '0'}</HeaderValue>
              <HeaderTitle>behind 1st</HeaderTitle>
            </HeaderSection>
          </Header>
          
          <LogoContainer>
            <Logo src="/images/eyo-icon.png" alt="Eyo Icon" />
          </LogoContainer>
        </div>
        
        <MainContent>
          {this.renderPoints()}
          {this.renderCountdown()}
          {this.renderGetReady()}
          {this.renderOptions()}
          {this.renderGameOver()}
        </MainContent>
        
        <Footer>
          <UserNameContainer>
            <UserName>{this.props.user.name}</UserName>
          </UserNameContainer>
          
          <StatsContainer>
            <StatsValue>
              {!this.props.question ? '' : this.props.question.index}/{!this.props.round ? '' : this.props.round.totalQuestions || '0'}
            </StatsValue>
            <StatsLabel>question</StatsLabel>
          </StatsContainer>
          
          <StatsContainer>
            <StatsValue>
              {!this.props.round ? '' : this.props.round.index}/{this.props.details?.totalRounds || ''}
            </StatsValue>
            <StatsLabel>round</StatsLabel>
          </StatsContainer>
        </Footer>
      </Container>
    );
  }
}
